import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
} from '@mui/material';
import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { HeadCellDto } from '../../services/dtos/head-cell.dto';
import { RowDto } from '../../services/dtos/row.dto';
import { CellDto } from '../../services/dtos/cell.dto';

/**
 * Composant du tableau générique
 * @param props rows utilisées
 *
 * @constructor
 */
export default function CustomTable(props: {
    rows: any;
    isSearching: boolean;
    headCells: HeadCellDto[];
    handleOnPageChange: any;
    page: number;
    rowsPerPage: number;
    totalItems?: number;
}) {
    // On retourne un tableau générique
    return (
        <TableContainer className={'containerTable'} component={Box} key={'key'}>
            {/* Affichage du tableau*/}
            <Table>
                <TableHead>
                    <TableRow>
                        {/*En-têtes*/}
                        {props.headCells.map(headCell => (
                            <TableCell key={headCell.id} align={'left'} sx={{ fontWeight: 'bold', fontSize: 'medium' }}>
                                {headCell.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                {/* Gestion du chargement des pages/tri avec une progress bar */}
                <TableBody>
                    {!props.isSearching ? (
                        // Lignes du tableau
                        props.rows?.map((row: RowDto) => (
                            <TableRow key={row.key}>
                                {row.value.map((cell: CellDto) => (
                                    <TableCell key={cell.key}>{cell.value}</TableCell>
                                ))}
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={props.headCells.length}>
                                <LinearProgress />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        {/*Options de pagination*/}
                        <TablePagination
                            count={Number(props.totalItems) ? Number(props.totalItems) : 0}
                            onPageChange={props.handleOnPageChange}
                            page={props.page}
                            rowsPerPage={props.rowsPerPage}
                            rowsPerPageOptions={[props.rowsPerPage]}
                            labelDisplayedRows={({ from, to, count }) => `${from} à ${to} sur ${count}`}
                            showFirstButton
                            showLastButton
                        />
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    );
}
